module.exports = __webpack_public_path__ + "static/media/down-arrow.7ba0756e.svg";